import { render, staticRenderFns } from "./ViewInventorySpecimens.vue?vue&type=template&id=2ee4e264&scoped=true"
import script from "./ViewInventorySpecimens.vue?vue&type=script&lang=js"
export * from "./ViewInventorySpecimens.vue?vue&type=script&lang=js"
import style0 from "./ViewInventorySpecimens.vue?vue&type=style&index=0&id=2ee4e264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee4e264",
  null
  
)

export default component.exports